import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef, useCallback, useContext, useEffect, useRef } from 'react';
import { useComponentTheme } from '../../../utils/hooks';
import { AccordionHeaderExpansionIndicator, AccordionHeaderIcon, AccordionHeaderRoot, AccordionHeaderTypography, AccordionHeaderBody } from './style';
import { accordionHeaderDefaultTheme } from './theme';
import { ACCORDION_HEADER_CLASS_PREFIX, accordionHeaderIcon, accordionHeaderRoot, accordionHeaderTypography } from '../constants';
import { DROPDOWN_ACTION_ITEM } from '../../Dropdown/constants';
import AccordionContext from '../AccordionContext';
import useAccordionHeaderClassName from './useAccordionHeaderClassName';
import { useInternalRef } from '../../../utils';
import { getWindow } from '../../../system/util/getWindow';
export var AccordionHeader = forwardRef(function AccordionHeader(_ref, ref) {
  var title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["title", "children", "className"]);

  var theme = useComponentTheme(ACCORDION_HEADER_CLASS_PREFIX, accordionHeaderDefaultTheme);

  var _useContext = useContext(AccordionContext),
      disabled = _useContext.disabled,
      isExpanded = _useContext.isExpanded,
      onToggle = _useContext.onToggle;

  var internalInputRef = useRef(null);
  var classOverride = useAccordionHeaderClassName(ACCORDION_HEADER_CLASS_PREFIX, className, disabled, isExpanded);
  useInternalRef(ref, internalInputRef);
  var enterKeyHandler = useCallback(function (event) {
    var key = event.key,
        target = event.target;

    if (target === internalInputRef.current && key === 'Enter') {
      if (onToggle) {
        onToggle(event);
      }
    }
  }, [internalInputRef, onToggle]);
  useEffect(function () {
    var win = getWindow();

    if (win && !disabled) {
      win.addEventListener('keyup', enterKeyHandler);
      return function () {
        win.removeEventListener('keyup', enterKeyHandler);
      };
    }

    return function () {};
  }, [disabled, isExpanded]);
  return React.createElement(AccordionHeaderRoot, Object.assign({
    "data-testid": accordionHeaderRoot
  }, restProps, {
    className: classOverride.Root,
    disabled: disabled,
    isExpanded: isExpanded,
    onClick: onToggle,
    ref: internalInputRef,
    tabIndex: 0,
    theme: theme
  }), React.createElement(AccordionHeaderBody, null, title && React.createElement(AccordionHeaderTypography, {
    className: classOverride.HeaderTitle,
    "data-testid": accordionHeaderTypography,
    disabled: disabled,
    label: true,
    large: true,
    theme: theme
  }, title), children), React.createElement(AccordionHeaderIcon, {
    className: classOverride.IconContainer,
    "data-testid": accordionHeaderIcon,
    disabled: disabled,
    isExpanded: isExpanded,
    theme: theme
  }, React.createElement(AccordionHeaderExpansionIndicator, {
    className: classOverride.ExpansionIndicator,
    disabled: disabled,
    isExpanded: isExpanded,
    onClick: function onClick() {},
    theme: theme,
    "data-testid": DROPDOWN_ACTION_ITEM
  })));
});